// src/components/canvas/SafeCanvas.jsx
import React from "react";
import { Canvas } from "@react-three/fiber";
import ThreeErrorBoundary from "../ThreeErrorBoundary";
import { isWebGLAvailable } from "../../utils/webgl";

const DefaultFallback = () => (
  <div className="w-full h-full min-h-[300px] rounded-xl bg-black/20 flex items-center justify-center">
    <p className="text-white/70 text-sm">Visual 3D no disponible en este navegador.</p>
  </div>
);

export default function SafeCanvas({ children, fallback, ...canvasProps }) {
  const Fallback = fallback ?? <DefaultFallback />;

  if (!isWebGLAvailable()) return Fallback;

  return (
    <ThreeErrorBoundary fallback={Fallback}>
      <Canvas
        dpr={1}
        gl={{ antialias: false, powerPreference: "low-power" }}
        {...canvasProps}
      >
        {children}
      </Canvas>
    </ThreeErrorBoundary>
  );
}